import { render, staticRenderFns } from "./Packages.vue?vue&type=template&id=211078cc&scoped=true"
import script from "./Packages.vue?vue&type=script&lang=ts"
export * from "./Packages.vue?vue&type=script&lang=ts"
import style0 from "./Packages.vue?vue&type=style&index=0&id=211078cc&prod&scoped=true&lang=css"
import style1 from "./Packages.vue?vue&type=style&index=1&id=211078cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211078cc",
  null
  
)

export default component.exports